import React from "react";
import { CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import LATheme from "../../theme/customTheme/customTheme";
import PropTypes from "prop-types";

const useStyles = makeStyles(theme => ({
	root: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		height: "100px"
	},
	spinner: {
		color: LATheme.palette.primary.main
	}
}));

export default function LoadingSpinner(props) {
	const { size } = props;

	const classes = useStyles();

	return (
		<div className={classes.root}>
			<CircularProgress className={classes.spinner} size={size} />
		</div>
	);
}

LoadingSpinner.defaultProps = {
	size: 75
};

LoadingSpinner.propTypes = {
	size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
